import { useQuery } from '@tanstack/react-query';

import type { LeadDetails } from '@ekhodealer/ekho-common';
import type { UseQueryResult } from '@tanstack/react-query';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { apiClient } from '@config/server/apiClient';
import { leadsEndpoints } from '@config/server/apiEndpoints';
import { queries } from '@config/server/queryKeys';

export const getLeadDetails = async (
	servicesProviderId: string,
	leadId: string,
	timezone?: string,
): Promise<LeadDetails> => {
	const tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
	const response = await apiClient.get<LeadDetails>(
		leadsEndpoints.details(servicesProviderId, leadId),
		{ params: { timezone: tz } },
	);
	return response.data;
};

export const useGetLeadDetails = (leadId: string | null | undefined): UseQueryResult<LeadDetails, Error> => {
	const servicesProviderId = useCurrentServicesProviderId();

	return useQuery({
		queryKey: queries.leads.detail(servicesProviderId, leadId || '').queryKey,
		queryFn: async () => {
			if (!leadId) {
				throw new Error('Unable to fetch lead without a lead ID.');
			}
			return getLeadDetails(servicesProviderId, leadId);
		},
		enabled: Boolean(leadId) && Boolean(servicesProviderId),
		staleTime: Infinity,
	});
};
